<template>
  <!-- 字体设置——右侧表格 -->
  <div class="fontRightTable">
    <!-- 表格 -->
    <el-table ref="fontRightTable" height="100%" border highlight-current-row tooltip-effect="dark"
      :data="fontRightData" :row-class-name="tableRowClassName" @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
      </template>
      <el-table-column type="selection" align="center" fixed="left">
      </el-table-column>
      <el-table-column type="index" label="序号" fixed="left" width="60">
      </el-table-column>
      <el-table-column label="Revit文字" prop="revitFont" align="center">
        <template #default="{ row }">
          <el-link type="primary" @click="openEditDialog(row)">
            <span class="tabLinkSpan" :title="row.revitFont">{{ row.revitFont }}</span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="CAD文字样式" prop="cadFontStyle" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="SHX字体" prop="shxFont" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="大字体" prop="bigFont" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="宽度因子" prop="widthFactor" align="center" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-link type="primary" @click="openEditDialog(scope.row)">编辑</el-link>
          <el-link type="primary" @click="deleteTableFont(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改弹框 -->
    <el-dialog v-dialogDrag :visible.sync="editSetOpen" title="修改设置" width="27%" top="17vh" class="dialogRevitAddSet" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 表单 -->
      <el-form ref="editForm" :model="editForm" size="small" label-width="120px" :rules="editRules">
        <el-form-item label="Revit文字" prop="revitFont">
          <el-input v-model.trim="editForm.revitFont" placeholder="请输入revit字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="CAD文字样式" prop="cadFontStyle">
          <el-input v-model.trim="editForm.cadFontStyle" placeholder="请输入cad字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="SHX字体" prop="shxFont">
          <el-input v-model.trim="editForm.shxFont" placeholder="请输入字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="大字体" prop="bigFont">
          <el-input v-model.trim="editForm.bigFont" placeholder="请输入字体类型" maxlength="50" clearable></el-input>
        </el-form-item>
        <el-form-item label="宽度因子" prop="widthFactor">
          <el-input-number v-model="editForm.widthFactor" placeholder="请输入宽度因子" :min="0.01" :max="100" :precision="2">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSetOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="editFontSetRight">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import revitSetService from "@/CommonDP/service/revitSet-service";

export default {
  components: {},
  props: ["fontStyleId"],
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      fontRightData: [], // 表格数据

      editSetOpen: false, // 编辑弹框
      editForm: {
        fontStyleDetailsId: "",
        revitFont: "",
        cadFontStyle: "",
        shxFont: "",
        bigFont: "",
        widthFactor: ""
      }, // 编辑表单
      editRules: {
        revitFont: [{ required: true, message: "revit字体类型不能为空", trigger: "blur" }],
        cadFontStyle: [{ required: true, message: "cad字体类型不能为空", trigger: "blur" }],
        widthFactor: [
          { required: true, message: "宽度因子不能为空", trigger: "blur" },
          { required: true, message: "宽度因子不能为空", trigger: "change" }
        ]
      } // 表单验证
    };
  },
  watch: {
    fontStyleId: {
      immediate: true,
      handler(val) {
        if (val) this.getFontRightData();
        else this.fontRightData = [];
      }
    }
  },
  mounted() {},
  methods: {
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },

    // 获取规则设置右侧数据
    async getFontRightData() {
      const res = await revitSetService.getFontRightData(this.fontStyleId);
      this.fontRightData = res.data;
    },
    // 表格当前行改变
    handleCurrentChange(row) {
      this.$emit("setCurrentRule", row);
    },
    // 表格选择数据改变
    handleSelectionChange(list) {
      this.$emit("setSelectFonts", list);
    },

    // 打开修改弹框
    openEditDialog(row) {
      this.editSetOpen = true;
      this.$nextTick(() => {
        this.editForm = {
          fontStyleDetailsId: row.fontStyleDetailsId,
          revitFont: row.revitFont,
          cadFontStyle: row.cadFontStyle,
          shxFont: row.shxFont,
          bigFont: row.bigFont,
          widthFactor: row.widthFactor
        }; // 修改表单
        this.$refs.editForm.resetFields();
      });
    },
    // 提交修改弹框
    editFontSetRight() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          const { fontStyleDetailsId, revitFont, cadFontStyle, shxFont, bigFont, widthFactor } = this.editForm;
          const params = {
            fontStyleDetailsId,
            revitFont,
            cadFontStyle,
            shxFont,
            bigFont,
            widthFactor
          };
          await revitSetService.editFontSetRight(params);
          await this.getFontRightData();
          this.$message.success("修改字体成功");
          this.editSetOpen = false;
        }
      });
    },

    // 删除表中规则
    deleteTableFont(row) {
      this.$confirm("此操作将删除本行数据，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        const list = [];
        list.push(row.fontStyleDetailsId);
        await revitSetService.deleteFontSetList(list);
        await this.getFontRightData();
        this.$message.success("删除成功");
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.fontRightTable {
  width: 100%;
  height: 100%;
  padding: var(--middle-space) var(--big-space);

  .el-table {
    .el-link {
      margin: 0 10px;
    }
  }
}

.el-input-number {
  width: 200px;
  max-width: 100%;
}

/deep/ .el-form-item__label {
  text-align: left;
}
</style>
